import React from 'react';
import { Line } from 'react-chartjs-2';

function LineChart(params) {
    return (
        <Line
            datasetIdKey='id'
            data={{
                labels: params.labels,
                datasets: params.datasets
            }}
            options={{
                plugins: {
                  title: {
                    display: true,
                    text: params.name
                  },
                },
                responsive: true,
              }}
        />

    )
}

export default LineChart;